<template>
  <img
    src="@/assets/coach_ai.png"
    alt="Coach AI"
    :width="width"
    :height="height"
    :style="{ objectFit: 'contain' }"
    :class="className"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CoachAIIcon',
  props: {
    width: {
      type: [Number, String],
      default: 24
    },
    height: {
      type: [Number, String],
      default: 24
    },
    class: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const className = props.class
    return {
      className
    }
  }
})
</script>
